import { useEffect, useMemo } from "react";
import { HydrationBoundary } from "@tanstack/react-query";
import { SearchContainer } from "@/components/search/SearchContainer";
import { formatTechnologyKey, TechnologyProfileHeader } from "@/components/technology/TechnologyProfileHeader";
import { useTranslation } from "@/lib/paraglide-react";
import { Route } from "/app/src/routes/{-$locale}/technologies/$id.tsx";
function TechnologyRoute() {
  const {
    dehydratedState
  } = Route.useLoaderData();
  return <HydrationBoundary state={dehydratedState}>
      <TechnologyPage />
    </HydrationBoundary>;
}
function TechnologyPage() {
  const {
    t
  } = useTranslation();
  const {
    id
  } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const fallbackName = formatTechnologyKey(id);
  const initialSearch = useMemo(() => ({
    ...search,
    technologies: undefined
  }), [search]);
  useEffect(() => {
    if (search.technologies === undefined) return;
    navigate({
      to: "/{-$locale}/technologies/$id",
      params: {
        id
      },
      search: initialSearch,
      replace: true,
      resetScroll: false
    });
  }, [id, initialSearch, navigate, search.technologies]);
  return <div className="flex min-h-[85vh] w-full flex-col gap-8 py-4">
      <TechnologyProfileHeader id={id} />

      <section>
        <SearchContainer contextId={`technology-${id}`} fixedParams={{
        technologies: [id]
      }} controls={{
        showTechnologies: false
      }} title={t("technologies.matchingGames", {
        name: fallbackName
      })} initialSearch={initialSearch} onSearchChange={nextSearch => {
        navigate({
          to: "/{-$locale}/technologies/$id",
          params: {
            id
          },
          search: {
            ...nextSearch,
            technologies: undefined
          },
          resetScroll: false
        });
      }} />
      </section>
    </div>;
}
export { TechnologyRoute as component };